<template>
  <v-dialog v-model="modalAberto" max-width="500px">
    <v-card>
      <v-card-title class="headline">Detalhes do Evento</v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <strong>Nome:</strong> {{ eventoSelecionado.name || "Não informado" }}
          </v-col>
          <v-col cols="12">
            <strong>Descrição:</strong> {{ eventoSelecionado.descricao || "Não informado" }}
          </v-col>
          <v-col cols="12">
            <strong>Data:</strong> {{ formatarData(eventoSelecionado.start) || "Não informado" }}
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="fecharModal">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    modalAberto: {
      type: Boolean,
      required: true,
    },
    eventoSelecionado: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    formatarData(data) {
      const date = new Date(data);
      date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
      return date.toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });
    },
    fecharModal() {
      this.$emit("fechar-modal");
    },
  },
};
</script>

<style scoped></style>
